// English translations for the order-flow area, keyed by the Russian source string.
export default {
  // Context / origin step
  'Выберите пункт отправления': 'Select origin',
  'Выберите тип использования': 'Select usage type',
  'Тип регистрации': 'Registration type',
  'Привезти в филиал': 'Bring to branch',
  'Привезёте лично в филиал.': 'You will bring it to the branch in person.',
  'Онлайн-регистрация': 'Online registration',
  'Отправите внутренней доставкой в филиал и введёте трек-номер.':
    'You will ship it to the branch via domestic delivery and enter a tracking number.',

  // Branch step
  'Не найдено доступных филиалов.': 'No available branches found.',
  'Филиал': 'Branch',
  'Филиал: ': 'Branch: ',
  'Выберите из филиалов, доступных для онлайн-приёма.': 'Choose from branches available for online intake.',
  'Выберите филиал для сдачи отправления.': 'Select a branch to drop off the shipment.',
  'Выберите филиал': 'Select branch',
  'Выбор филиала': 'Select a branch',
  'кг': 'kg',
  'Типы отправлений, принимаемые этим филиалом': 'Shipment types accepted by this branch',

  // Shipment / payment step
  'Тип отправления': 'Shipment type',
  'Этот филиал принимает только тип «': 'This branch only accepts the type «',
  '».': '».',
  'Выберите тип отправления': 'Select shipment type',
  'Сумма отправления': 'Shipment amount',
  'Введите сумму отправления': 'Enter the shipment amount',
  'Введите сумму': 'Enter amount',
  'Введите трек-номер': 'Enter tracking number',
  'Трек-номер': 'Tracking number',
  'Добавить': 'Add',
  'Удалить': 'Delete',
  'Комментарий (необязательно)': 'Comment (optional)',
  'Тип оплаты': 'Payment type',
  'Выберите тип оплаты': 'Select payment type',
  'Наличные': 'Cash',
  'Перевод': 'Transfer',
  'Карта': 'Card',
  'В Кыргызстане': 'In Kyrgyzstan',

  // Party step
  'Выберите отправителя и получателя': 'Select sender and receiver',
  'Выберите отправителя': 'Select sender',
  'Выберите получателя': 'Select receiver',
  'Отправитель': 'Sender',
  'Получатель': 'Receiver',
  '+ Добавить отправителя': '+ Add sender',
  '+ Добавить получателя': '+ Add receiver',
  'Данные отправителя': 'Sender details',
  'Данные получателя': 'Receiver details',
  'Выбор отправителя': 'Select sender',
  'Выбор получателя': 'Select receiver',
  'Поиск': 'Search',
  'Страна': 'Country',
  'Нет данных': 'No data',

  // Review step
  'Общая информация': 'General information',
  'Пункт отправления': 'Origin',
  'Тип использования': 'Usage type',
  'Онлайн-приём': 'Online intake',
  'Доставка': 'Delivery',
  'Да': 'Yes',
  'Нет': 'No',
  'Адрес доставки': 'Delivery address',
  'Отправление и оплата': 'Shipment and payment',
  'Получить доставкой?': 'Receive by delivery?',
  'Введите адрес доставки': 'Enter the delivery address',
  'Получать СМС': 'Receive SMS',
  'Получать эл. почту': 'Receive email',
  'Дополнительный комментарий': 'Additional comment',
  'Введите комментарий...': 'Enter a comment...',

  // Steps / navigation
  'Начало': 'Start',
  'Отправление, сумма, оплата': 'Shipment, amount, payment',
  'Клиент': 'Client',
  'Проверка': 'Review',
  'Назад': 'Back',
  'Далее': 'Next',
  'Сохранить': 'Save',
  'Создать регистрацию': 'Create registration',
  'Зарегистрировать ещё': 'Register another',
  'Завершить': 'Finish',

  // Notifications / validation labels
  'Произошла ошибка': 'An error occurred',
  'Заполните обязательные поля и нажмите «Далее», чтобы продолжить.': 'Fill in the required fields and click «Next» to continue.',
  'Отправление успешно изменено': 'Shipment updated successfully',
  'Не хватает данных': 'Missing information',
  'Страна отправления': 'Origin country',
  'Сумма': 'Amount',
  'Тип содержимого': 'Content type',

  // Success modal
  'Ваш груз успешно зарегистрирован в нашей системе.': 'Your cargo has been successfully registered in our system.',
  'Подробную информацию о грузе смотрите на веб-портале.': 'See detailed cargo information on the web portal.',
}
